import { combineReducers } from 'redux';

import detailsReducer from './details';
import formVoteReducer from './form-vote';
import layerReducer from './layers';
import detailLayerReducer from './layers-details';

const homeReducer = combineReducers({
  details: detailsReducer,
  formVote: formVoteReducer,
  layer: layerReducer,
  detailLayer: detailLayerReducer,
})

export default homeReducer;
